import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2b38a4f2&"
import script from "./Footer.ts?vue&type=script&lang=ts&"
export * from "./Footer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports